// extracted by mini-css-extract-plugin
export default {"root":"GlobalError_root__FfkT1","errorText":"GlobalError_errorText__seRAs"};